// extracted by mini-css-extract-plugin
export default {"title":"_6acaacad3b","inner_title":"_3c27bcb779","charge_btn":"_0a19d28e76"};